// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"a1555fb3","453":"c84db98c","692":"3d2a2be4"}[chunkId] + ".chunk.js";
};